import React, { useState, useEffect } from 'react';

const inputStyle = { background: '#0d0d0d', border: '1px solid #2a2a2a', color: 'white' };

function GenreForm({ initialData, onSubmit, onCancel, title = 'Add Genre' }) {
  const [formData, setFormData] = useState({ name: '', description: '' });
  const [errors, setErrors] = useState({});
  const [focusedField, setFocusedField] = useState(null);

  useEffect(() => {
    if (initialData) setFormData({ name: initialData.name || '', description: initialData.description || '' });
  }, [initialData]);

  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = 'Name is required';
    if (formData.name.length > 100) newErrors.name = 'Name must be less than 100 characters';
    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) { setErrors(validationErrors); return; }
    onSubmit(formData);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
  };

  const getFieldStyle = (fieldName) => ({
    ...inputStyle,
    ...(focusedField === fieldName ? { borderColor: 'rgba(220,38,38,0.6)', boxShadow: '0 0 0 2px rgba(220,38,38,0.1)', outline: 'none' } : {}),
    ...(errors[fieldName] ? { borderColor: '#dc2626' } : {}),
  });

  return (
    <div className="rounded-xl overflow-hidden" style={{ background: '#111', border: '1px solid #1f1f1f' }}>
      <div className="px-6 py-4 flex items-center justify-between" style={{ borderBottom: '1px solid #1a1a1a', background: '#0d0d0d' }}>
        <div className="flex items-center gap-3">
          <div className="w-7 h-7 rounded-lg flex items-center justify-center" style={{ background: '#dc2626' }}>
            <svg className="w-3.5 h-3.5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
            </svg>
          </div>
          <h2 className="text-base font-black text-white uppercase tracking-wide">{title}</h2>
        </div>
        <button onClick={onCancel} style={{ color: '#6b7280' }} className="hover:text-white transition-colors">
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <form onSubmit={handleSubmit} className="p-6">
        <div className="space-y-5">
          <div>
            <label className="block text-xs font-semibold uppercase tracking-wider mb-2" style={{ color: '#9ca3af' }}>Name *</label>
            <input
              type="text" name="name" value={formData.name} onChange={handleChange}
              className="w-full px-4 py-3 rounded-lg text-sm text-white placeholder-gray-600 transition-all"
              style={getFieldStyle('name')}
              onFocus={() => setFocusedField('name')} onBlur={() => setFocusedField(null)}
              placeholder="Enter genre name"
            />
            {errors.name && <p className="mt-1 text-xs" style={{ color: '#f87171' }}>{errors.name}</p>}
          </div>

          <div>
            <label className="block text-xs font-semibold uppercase tracking-wider mb-2" style={{ color: '#9ca3af' }}>Description</label>
            <textarea
              name="description" value={formData.description} onChange={handleChange} rows="4"
              className="w-full px-4 py-3 rounded-lg text-sm text-white placeholder-gray-600 transition-all resize-none"
              style={getFieldStyle('description')}
              onFocus={() => setFocusedField('description')} onBlur={() => setFocusedField(null)}
              placeholder="Enter genre description (optional)"
            />
          </div>
        </div>

        <div className="flex gap-3 mt-6">
          <button type="submit" className="flex-1 py-3 rounded-lg font-bold text-white text-sm transition-all hover:opacity-90"
            style={{ background: '#dc2626' }}>
            {initialData ? 'Update Genre' : 'Create Genre'}
          </button>
          <button type="button" onClick={onCancel} className="flex-1 py-3 rounded-lg text-sm font-medium transition-all"
            style={{ background: '#0d0d0d', color: '#9ca3af', border: '1px solid #2a2a2a' }}>
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
}

export default GenreForm;